import _ from 'lodash';

export const isAuthenticated = (context) => !!_.get(context, 'entities.session.accessToken');

export const isStartingUp = (context) => !!_.get(context, 'state.startupLoading');

export const getUserId = (context) => _.get(context, 'entities.session.user.id');
export const getUser = (context) => _.get(context, 'entities.session.user');
